import React from 'react';

import type { Os } from '../types';

import { LinuxTerminalBody } from './LinuxTerminalBody';
import { MacOSTerminalBody } from './MacOSTerminalBody';
import { WindowsTerminalBody } from './WindowsTerminalBody';

type TerminalBodyProps = {
	os: Os;
};

export const TerminalBody = ({ os }: TerminalBodyProps): JSX.Element => {
	switch (os) {
		case 'macos':
			return <MacOSTerminalBody />;
		case 'linux':
			return <LinuxTerminalBody />;
		case 'windows':
			return <WindowsTerminalBody />;
	}
};
